import { Injectable } from '@angular/core';

interface Feature {
  enabled: boolean;
  route?: string;
  redirectionRoute?: string;
}

export enum TokenType {
  AccessToken = 'accessToken',
  IdToken = 'idToken',
}

@Injectable({ providedIn: 'root' })
export class EnvService {
  public environment = 'local';
  public enableDebug = true;

  public test = {
    basicToken: '',
  };

  public api = {
    useMock: false,
    mockDelay: 200,
    baseUrl: '',
  };

  public okta = {
    oidc: {
      clientId: '',
      issuer: '',
      redirectUri: '',
      scopes: [],
      postLogoutRedirectUri: '',
      testing: {
        disableHttpsCheck: true,
      },
      cookies: {
        sameSite: 'none',
      },
    },
    agentsGroupName: 'AGENTS',
  };

  public addressVerification = {
    apiBaseUrl: '',
    userId: '',
  };

  public sessionExpiration = {
    sessionDurationInMinutes: 10,
    sessionExpirationWarningThresholdInMinutes: 8,
  };

  public medicalProfile = {
    url: '',
  };

  public ipAddress = {
    url: '',
  };

  public ccs = {
    helpPhone: '',
    helpFax: '',
    helpEmail: '',
    termsAndConditionsUrl: '',
    privacyUrl: '',
  };

  public versionUpdates = {
    checkPeriodInMinutes: 0,
  };

  public sentry = {
    enabled: false,
    dsn: '',
    normalizeDepth: 0,
    scrubKeys: [] as string[],
  };

  public googleAnalytics = {
    measurementId: '',
    hashSalt: '',
  };

  public captcha = {
    siteKey: '',
  };

  public billMatrix = {
    url: '',
  };

  public legacyPortal = {
    url: 'https://legacydev.myccsmed.com/portal4/LoginNew',
  };

  public notifications = {
    cgm90EnrollmentActionId: 'CGM90ENROLL',
  };

  public features: { [key: string]: Feature } = {
    registration: {
      enabled: true,
      route: '/login/new',
      redirectionRoute: '/login',
    },
    addressOrdersChangeModal: {
      enabled: true,
    },
    makePaymentPage: {
      enabled: false,
    },
    notifications: {
      enabled: true,
    },
    copayExclusion: {
      enabled: true,
    },
    deductibleOverrides: {
      enabled: true,
    },
    newLeafPharmacy: {
      enabled: true,
    },
  };

  constructor() {}

  isProduction(): boolean {
    return this.environment === 'production';
  }
}
